export function isTelNr(value) {
    return /^\d{0,12}$/.test(value || '');
}
